import ReactDOM from "react-dom/client";
import App from "./App";
import { useLoginProvide } from "./hooks/login";
import "./index.css";
import { getQueryVariable } from "./utils/http";
import store from "./store";
import "./assets/css/tailwind.css";
import { EActionType } from "./store/globle/types";
import "./assets/css/tailwind.css";
import "./assets/iconfont/iconfont.css";
import __bl from "./utils/arms-logger";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
// console.log( process.env.argv ,77878);

// 没登陆
// 用接口拦截
if(!window.location.hash.includes('/schoolDiagnose')){
  (async () => {
    let userInfo = JSON.parse(localStorage.getItem("intelli_userInfo")!);
    // let hasLogin = JSON.parse(localStorage.getItem("hasLogin")!);
    // let LocalToken = JSON.parse(localStorage.getItem("intelli_token")!);
    // token 可以从两个地方得到   cookie / url   先从cookie拿

    const token = getQueryVariable("token");
    const login = useLoginProvide();
    // 有token, 请求接口   本地的话需要手动更新
    // userInfo是不会过期的  authorization  token会过期
    if (!userInfo) {
      if (token) {
        // await verify(token)
        userInfo = await login.getUserInfo();
        if (userInfo) {
          // 登录成功后，保存登录状态
          localStorage.setItem("intelli_userInfo", JSON.stringify(userInfo));
          // localStorage.setItem("hasLogin", JSON.stringify(hasLogin));
          // localStorage.setItem("intelli_token", JSON.stringify(token));
        }
      } else {
        // 跳转登录页
        login.toLoginOut();
      }
    }
    //
    return {
      // hasLogin,
      userInfo,
    };
  })()
      .then(async (data) => {
        if (data.userInfo) {
          store.dispatch({ type: EActionType.USERINFO, userInfo: data.userInfo });
          if (data.userInfo?.name && data.userInfo?.workcode) {
            __bl.setConfig({
              uid: data.userInfo.workcode,
              setUsername() {
                return data.userInfo.name;
              },
              // ignore: {
              //   ignoreErrors: [
              //     function (str: string) {
              //       if (str && str.indexOf("Cannot create property 'info' on string ''") >= 0) return true; // 不上报
              //       return false; // 上报
              //     }
              //   ]
              // }
            });
          }
          root.render(<App />);
        }
      })
      .catch((e: any) => {
        return Promise.reject(e);
      });
}else {
  root.render(<App />);
}
//https://yach-oapi.zhiyinlou.com/robot/send?access_token=VGozTlhlRVFqdW9IWWxZbkU3K3Vka0pNZE5BK0F6b0VXQ3RSSGpJM29FblVBYk9OcFF6Qlh0VXRtL2tYSDhjcw
